// app
export const width = state => state.app.width
export const height = state => state.app.height
export const device = state => state.app.device
export const touch = state => state.app.touch
export const color = state => state.app.color
export const fetched = state => state.app.fetched
export const data = state => state.app.data
export const filtered = state => state.app.filtered
export const mask = state => state.app.mask
export const category = state => state.app.category

// data
export const categories = state => filterByCategories(state.app.data)

// helpers
function imagesByCategory (images, slug) {
	return images.filter(i => i.data.category.slug === slug)
}

function filterByCategories (data) {
	if (!data) return
	return Object.values(data.reduce((r, e) => {
		let images = imagesByCategory(data, e.data.category.slug)
		var key = e.data.category.slug
		if (!r[key]) {
			r[key] = {}
			r[key].resources = images
			r[key].slug = e.data.category.slug
			r[key].category = e.data.category.data.name
			r[key].mask = e.data.category.slug
			r[key].count = images.length
			r[key].soon = images.some((i) => { return i.data.category.data.featured === 'No' })
		}
		return r
	}, {}))
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js